import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listContainer: {
      backgroundColor: '#FFFFFF',
      borderRadius: 5
    },
    tableTopContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingBottom: 15
    },
    selectBox: {
      border: 1,
      borderStyle: 'solid',
      borderColor: '#758283',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: 5,
      overflow: 'hidden'
    },
    selectBoxInRow: {
      backgroundColor: '#FFFFFF',
      fontSize: '0.9em',
      paddingLeft: '5px',
      paddingRight: '5px',
      minWidth: '90px'
    },
    tableContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start'
    },
    listTableButtonBox: {
      display: 'flex',
      height: 36.5
    },
    headerCellLarge: {
      minWidth: 180
    },
    headerCellMedium: {
      minWidth: 113
    },
    headerCellSmall: {
      minWidth: 100
    },
    textAlignCenter: {
      textAlign: 'center'
    },
    centerMessage: {
      textAlign: 'center'
    },
    detailCellWordBreak: {
      wordBreak: 'break-all'
    },
    loadingContainer: {
      height: 650,
      backgroundColor: '#F5F5F5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    loadingIconClearWrapper: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      marginTop: '-12px',
      marginLeft: '-100px',
      zIndex: 1
    }
  })
);
